import * as Constants from "../../constants";
import axios, { AxiosError } from 'axios';

export class ConfigService {
    
    constructor() {
    }
    
    async getAllParameters(key: string| null){
        try{
            const response=  await axios.get(`${(Constants.AUTH_API_URL ?? '')}?key=${key}`);
            return response.data;
        }catch (error){
            console.error(error);
			
			const axiosError = error as AxiosError;
			//Default error message
			let errorMessage = "4001";
			if(axiosError.response && axiosError.response.data){
				errorMessage = ""+axiosError.response.data;
			}
			if(axiosError.response && axiosError.response.status){
				errorMessage += " code: "+axiosError.response.status;
			}
			return {error: true, errorMessage: errorMessage, parameters: null}
        }

    }
}
